module.exports = __webpack_public_path__ + "img/voice_2.3c6e7440.svg";